import Modal from 'utils/packages/Modal';
import { getStripeSubscriptionPurchasePreview, } from 'features/premium/actions/stripe';
import { muteErrorAndResult, useFetchOld } from 'hooks/useFetch';
import React, { useCallback } from 'react';
import { useAppStore } from 'store/hooks';
import PremiumSubscriptionPurchasePreviewModal from '../components/PremiumSubscriptionPurchasePreviewModal';
const usePurchasePreviewModal = () => {
    const [, , isFetchingStripePreview, fetch] = useFetchOld(muteErrorAndResult);
    const store = useAppStore();
    const openPurchasePreviewModal = useCallback(async ({ subscription, discount, onPressContinue, formattedDiscountPrices, skipFreeTrial, variant, isRefundFlow, }) => {
        if (discount && discount.type !== 'stripe') {
            throw new Error('Discount modal only supports stripe discounts');
        }
        const { emmaProStatus } = store.getState().user.user;
        const isSubscriptionChange = emmaProStatus?.active && emmaProStatus.store === 'stripe';
        const prorationDate = isSubscriptionChange
            ? new Date().toISOString()
            : undefined;
        const result = await fetch(getStripeSubscriptionPurchasePreview({
            priceId: subscription.id,
            couponId: discount?.discount?.couponId,
            prorationDate,
            isSubscriptionChange,
            skipFreeTrial,
            isRefundFlow,
        }));
        if (discount ||
            result?.credit ||
            isSubscriptionChange ||
            emmaProStatus.usedFreeTrial) {
            if (result) {
                Modal.show(<PremiumSubscriptionPurchasePreviewModal tier={subscription.tier} period={subscription.period} currency={subscription.currency} previewData={result} variant={variant} onPressContinue={async () => {
                        await onPressContinue(result.payToday, prorationDate);
                    }} reopen={() => {
                        openPurchasePreviewModal({
                            subscription,
                            discount,
                            onPressContinue,
                            formattedDiscountPrices,
                            variant,
                            isRefundFlow,
                        });
                    }}/>, { containerStyle: { paddingHorizontal: 0 } });
            }
        }
        else {
            await onPressContinue();
        }
    }, []);
    return { openPurchasePreviewModal, isFetchingStripePreview };
};
export default usePurchasePreviewModal;
